export default function getFirstName(fullname) {
  var firstName = fullname.replace(/ .*/, '');
  return firstName;
}
